module.exports = __webpack_public_path__ + "static/media/avatar-new.69f7b5a6.png";